const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  active ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review-code/active', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
